import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CLIENT_SERVICE_IMPL, IAPIClientService } from 'shared';
import { CourierReportConfiguration, CourierReportRunStatus } from './courier-report-settings.models';

@Injectable({ providedIn: 'root' })
export class CourierReportSettingsService {
    constructor(
        @Inject(API_CLIENT_SERVICE_IMPL) private _apiClient: IAPIClientService
    ) {}

    public getEffective(countryCode: string): Observable<CourierReportConfiguration> {
        return this._apiClient.get<CourierReportConfiguration>(
            `courier-report/configuration?countryCode=${encodeURIComponent(countryCode)}`
        );
    }

    public getHistory(countryCode: string): Observable<CourierReportConfiguration[]> {
        return this._apiClient.get<CourierReportConfiguration[]>(
            `courier-report/configuration/history?countryCode=${encodeURIComponent(countryCode)}`
        );
    }

    public createVersion(
        configuration: CourierReportConfiguration
    ): Observable<HttpResponse<CourierReportConfiguration>> {
        return this._apiClient.postWithResponse<CourierReportConfiguration>(
            'courier-report/configuration',
            configuration
        );
    }

    public startRun(dryRun: boolean): Observable<HttpResponse<CourierReportRunStatus>> {
        return this._apiClient.postWithResponse<CourierReportRunStatus>(
            'courier-report/runs',
            { countryCode: 'HU', dryRun }
        );
    }

    public getRun(runId: string): Observable<CourierReportRunStatus> {
        return this._apiClient.get<CourierReportRunStatus>(`courier-report/runs/${runId}`);
    }

    public exportReport(report: 'szb' | 'sum'): Observable<HttpResponse<Blob>> {
        return this._apiClient.getBlobWithResponse(
            `courier-report/runs/export/${report}?countryCode=HU`
        );
    }
}
